module.exports = __webpack_public_path__ + "img/coming-soon.4d60131d.jpg";